import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { IngredientForm } from '@/features/ingredients/IngredientForm';
import { useCreateIngredient } from '@/features/ingredients/api';
import { defaultFormValues } from '@/features/ingredients/formMapping';
import type { CreateIngredientInfoInput } from '@honeycomb/shared';

export const Route = createFileRoute('/_authed/ingredients/new')({
  validateSearch: (search: Record<string, unknown>): { name?: string } => ({
    name: typeof search.name === 'string' ? search.name : undefined,
  }),
  component: NewIngredient,
});

function NewIngredient() {
  const navigate = useNavigate();
  const create = useCreateIngredient();
  const search = Route.useSearch();

  const handleSubmit = async (payload: CreateIngredientInfoInput) => {
    await create.mutateAsync(payload);
    await navigate({ to: '/ingredients' });
  };

  return (
    <div>
      <header className="px-8 pt-8 flex items-center gap-4">
        <div>
          <h1 className="font-serif text-3xl leading-tight">New ingredient</h1>
        </div>
        <div className="ml-auto">
          <button
            type="button"
            onClick={() => navigate({ to: '/ingredients' })}
            className="text-sm text-ink-soft hover:text-ink"
          >
            Cancel
          </button>
        </div>
      </header>
      <IngredientForm
        mode="create"
        initialValues={defaultFormValues({ name: search.name })}
        onSubmit={handleSubmit}
        isSubmitting={create.isPending}
      />
    </div>
  );
}
